import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import find from 'lodash/find';

import { useLagoon } from '../../../hooks/useLagoon';
import { shouldUseGehaV2Styling } from '../../../utils/gehaThemeUtils';
import { ConstantsLagoon } from '../../ConstantsLagoon';
import {
  CostHeader,
  CostTopSection,
  InNetworkContainer,
  InNetworkTextContainer,
  SectionText,
} from './Cost.styled';

type Props = {
  inNetwork: string;
};
export const InNetworkSection = ({ inNetwork }: Props) => {
  const data = useLagoon('ui-messaging')();
  const inNetworkText = find(data, {
    key: ConstantsLagoon.CONTENT_FILTERS.COST_TAB_IN_NETWORK_TEXT,
  });
  const inNetworkHeading = find(data, {
    key: ConstantsLagoon.CONTENT_FILTERS.COST_TAB_IN_NETWORK_HEADING,
  });

  const isGEHAV2 = shouldUseGehaV2Styling();

  if (inNetwork === 'In-network') {
    return (
      <CostTopSection>
        <InNetworkContainer alignItems="top">
          <IconSymbol color="$core.color.green.100" icon="check_circle" />
          <InNetworkTextContainer>
            <Heading
              css={CostHeader}
              data-auto-testid="cost-tab-in-network-heading"
              data-testid="cost-tab-in-network-heading"
              level={2}
              size="xs"
            >
              {inNetworkHeading?.message ?? ''}
            </Heading>
            <SectionText cssProps={{ isGEHAV2 }}>
              {inNetworkText?.message ?? ''}
            </SectionText>
          </InNetworkTextContainer>
        </InNetworkContainer>
      </CostTopSection>
    );
  }
  return null;
};
